import { GetterTree } from 'vuex';
import { IPropertyEditState } from '../property-states.store';

const propertyFinanceGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{

}

export default propertyFinanceGetters;